import { inject, InjectionToken } from '@angular/core';
import { Socket } from 'socket.io-client';

import ENV_NAMES from '../../environments/ENV_NAMES';

import { AppConfig } from './models/AppConfig';

function createAppConfigInjectionToken<T>(tokenName: string, selector: (appConfig: AppConfig) => T): InjectionToken<T> {
    return new InjectionToken<T>(tokenName, {
        providedIn: 'root',
        factory: () => {
            const appConfig = inject(APP_CONFIG);
            return selector(appConfig);
        },
    });
}

export const WINDOW_OBJECT = new InjectionToken<Window>('WINDOW_OBJECT');
export const WEBSOCKET = new InjectionToken<Socket>('WEBSOCKET');
export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export const IS_NO_PROD_ENV = createAppConfigInjectionToken(
    'IS_DEV_ENV',
    (config) => config.name === ENV_NAMES.DEV || config.name === ENV_NAMES.TEST,
);

export const ENDUSER_OFFER_OID = createAppConfigInjectionToken(
    'ENDUSER_OFFER_OID',
    (config) => config.bobApi.endUserOfferOID,
);

export const INSTALLER_OFFER_OID = createAppConfigInjectionToken(
    'INSTALLER_OFFER_OID',
    (config) => config.bobApi.installerOfferOID,
);
